import { createAsyncThunk } from '@reduxjs/toolkit';
import { Post, Get, Put } from "../../utils/apiUtils";
import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

export const KPIExtraReducer = (builder: ActionReducerMapBuilder<any>) => {
    // Add your async thunks and reducers here, similar to dashboardThunk
    builder
        .addCase(getKPI.pending, (state) => {
            state.isEnquiring = true;
            state.loadingKPI = true;
        })
        .addCase(getKPI.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.loadingKPI = false;
            state.kpiData = action.payload;
        })
        .addCase(getKPI.rejected, (state) => {
            state.isEnquiring = false;
            state.loadingKPI = false;
        })
        .addCase(saveKpiGroup.pending, (state) => {
            state.isEnquiring = true;
        })
        .addCase(saveKpiGroup.fulfilled, (state, action) => {
            state.isEnquiring = false;
        })
        .addCase(saveKpiGroup.rejected, (state) => {
            state.isEnquiring = false;
        })
        .addCase(createKPI.pending, (state) => {
            state.isEnquiring = true;
        })
        .addCase(createKPI.fulfilled, (state, action) => {
            state.isEnquiring = false;
        })
        .addCase(createKPI.rejected, (state) => {
            state.isEnquiring = false;
        })
        .addCase(generateKPI.pending, (state) => {
            state.isEnquiring = true;
        })
        .addCase(generateKPI.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.generatedKpiResponse = action.payload;
        })
        .addCase(generateKPI.rejected, (state) => {
            state.isEnquiring = false;  
        })
        .addCase(getKPIById.pending, (state) => {
            state.isEnquiring = true;
            state.generatedKpiResponse = {};
        })
        .addCase(getKPIById.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.kpi = action.payload;
        })
        .addCase(getKPIById.rejected, (state) => {
            state.isEnquiring = false;
        })
        .addCase(updateKpi.pending, (state) => {
            state.isEnquiring = true;
        })
        .addCase(updateKpi.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.generatedKpiResponse = {};
        })
        .addCase(updateKpi.rejected, (state) => {
            state.isEnquiring = false;
        })
};

// Example async thunk
export const getKPI = createAsyncThunk('kpi/getKPI', async (_, thunkAPI) => {
    // Replace with actual API call
    const response = await Get('/kpi', {});
    return response;
});

export const saveKpiGroup = createAsyncThunk('kpi/saveKpiGroup', async (kpiGroupData: any, thunkAPI) => {
    const response = await Post('/kpi/group', kpiGroupData, { msgKey: 'kpi' });
    return response;
});

export const createKPI = createAsyncThunk('kpi/createKPI', async (kpiData: any, thunkAPI) => {
    const response = await Post('/kpi/create', kpiData, { msgKey: 'kpi' });
    return response;
});

export const generateKPI = createAsyncThunk('kpi/generateKPI', async (params: any, thunkAPI) => {
    const response = await Post('/kpi/generate', params, { msgKey: 'kpi' });
    return response;
});

export const getKPIById = createAsyncThunk('kpi/getKPIById', async (id: string, thunkAPI) => {
    const response = await Get(`/kpi/${id}`, {});
    return response;
});

export const updateKpi = createAsyncThunk('kpi/updateKpi', async (kpiData: any, thunkAPI) => {
    const response = await Put(`/kpi/${kpiData._id}`, kpiData, { msgKey: 'kpi' });
    return response;
});